import { render } from "./SessionExpire.vue?vue&type=template&id=f05706c4"
import script from "./SessionExpire.vue?vue&type=script&lang=js"
export * from "./SessionExpire.vue?vue&type=script&lang=js"

import "./SessionExpire.vue?vue&type=style&index=0&id=f05706c4&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.25_vue@3.5.25_typescript@5.4.2__webpack@5.103.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__